import { render } from "./FillInformationGiftcard.vue?vue&type=template&id=4fcaa7aa"
import script from "./FillInformationGiftcard.vue?vue&type=script&lang=js"
export * from "./FillInformationGiftcard.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__